<template>
	<div class="wrapper wrapper-content h100pp" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="float-e-margins ibox-content animated fadeInRight h100pp">
				<div class="row h100pp" style="overflow: auto; height: calc(100% - 70px);">
					<div class="form-horizontal h100pp">
						<div class="col-sm-3 gray_right02 h100pp">
							<div class="col-sm-6 text-left">
								<button class="btn btn-primary" @click="toSync">一键同步</button>
							</div>
							<div class="col-sm-6 text-rigth">
								<button class="btn btn-primary" @click="addCarBrand">添加品牌</button>
							</div>
							<div class="col-sm-12">
								<div class="ibox-content" style="position: absolute; overflow: auto;">
									<ul id="carTree" class="ztree" style="height:600px; width:350px;"></ul>
								</div>
							</div>
						</div>
						<div class="col-sm-1 gray_left02 h100pp">
						</div>
						<div class="col-sm-8 h100p">
							<div class="col-sm-12 text-center " v-if="fatr==3">
								<p style="line-height:100%">请维护车辆信息</p>
							</div>
							<div class="col-sm-12"  v-show="fatr==1">
								<div class="form-horizontal">
									<div class="form-group">
										<div class="col-sm-12">
											<label for="">{{carBrandEditMsg}}</label>
										</div>
									</div>
									<div class="form-group">
										<div class="center-block text-center">
											<label class="col-sm-3 control-label">品牌名称</label>
											<div class="col-sm-3">
												<input type="text" class="form-control menuInput" v-model="carBrand.name"/>
											</div>
										</div>
										
									</div>
									<div class="form-group">
										<div class="center-block text-center">
											<label class="col-sm-3 control-label">全称</label>
											<div class="col-sm-3">
												<input type="text" class="form-control menuInput" v-model="carBrand.fullName"/>
											</div>
										</div>
									</div>
									<div class="form-group">
										<div class="center-block text-center">
											<label class="col-sm-3 control-label">首字母</label>
											<div class="col-sm-3">
												<input type="text" class="form-control menuInput" v-model="carBrand.initial"/>
											</div>
										</div>
									</div>
									<div class="form-group">
										<div class="center-block text-center">
											<label class="col-sm-3  control-label">LOGO</label>
											<div class="col-sm-9">
													<div class="uploadedImg t_left col-sm-3" style="height:100px;line-height: 100px;width:100px">
															<img :src="logoSrcBrand" class="img-responsive"/>
														</div>
														<vue-core-image-upload
															extensions="png,gif,jpeg,jpg"
															input-accept="image/jpg,image/jpeg,image/png"
															v-bind:crop="false"
															v-on:imageuploaded="imageuploadedBrand"						
															text="上传"
															inputOfFile="file"
															:url="picUrl"
															:headers="{'access-token':this.accesstoken}"
															v-bind:class="['btn','btn-primary','col-sm-2','col-offset-sm-1']"
															>
														</vue-core-image-upload>
														<span class="col-sm-7 control-label gray t_left">请上传jpg、jpeg或png格式的图片</span>
													</div>
											</div>
										</div>
									</div>
									<div class="text-center form-group col-sm-9">
										<button class="btn btn-primary" @click="confirmBrand">{{carBrandEditBtn}}</button>
									</div>
							</div>
								<div class="col-sm-12">
										<div class="col-sm-12 h100pp"  v-show="fatr==2">
											<div class="form-group">
												<label>{{carSeriesEditMsg}}</label>
											</div>
											<div class="form-group">
												<div class="center-block text-center">
													<label class="col-sm-3 control-label">车系</label>
													<div class="col-sm-3">
														<input type="text" class="form-control menuInput" v-model="carSeries.serialName"/>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="center-block text-center">
													<label class="col-sm-3  control-label">LOGO</label>
													<div class="col-sm-9">
														<div class="uploadedImg t_left col-sm-3" style="height:100px;line-height: 100px;width:100px">
																<img :src="logoSrcSeries" class="img-responsive"/>
														</div>
														<vue-core-image-upload
																extensions="png,gif,jpeg,jpg"
																input-accept="image/jpg,image/jpeg,image/png"
																v-bind:crop="false"
																v-on:imageuploaded="imageuploadedSeries"						
																text="上传"
																inputOfFile="file"
																:url="picUrl"
																:headers="{'access-token':this.accesstoken}"
																v-bind:class="['btn','btn-primary','col-sm-2','col-offset-sm-1']"
																>
														</vue-core-image-upload>
														<span class="col-sm-7 control-label gray t_left">请上传jpg、jpeg或png格式的图片</span>
													</div>
												</div>
											</div>
											<div class="text-center form-group col-sm-9">
												<button class="btn btn-primary" @click="confirmSeries">{{carSeriesEditBtn}}</button>
											</div>
										</div>
								</div>
								<div class="col-sm-12">
									<div class="col-sm-12 h00pp" v-show="fatr==0">
										<div class="form-group">
											<label >{{carTypeEditMsg}}</label>
										</div>
										<div class="form-group">
											<label class="col-sm-3 control-label">车型</label>
											<div class="col-sm-3">
												<input type="text" class="form-control menuInput"  v-model="carType.modelName"/>
											</div>
										</div>
										<div class="form-group">
											<div class="center-block text-center">
												<label class="col-sm-3  control-label">LOGO</label>
												<div class="col-sm-9">
													<div class="uploadedImg t_left col-sm-3" style="height:100px;line-height: 100px;width:100px">
														<img :src="logoSrcType" class="img-responsive"/>
													</div>
													<vue-core-image-upload
																extensions="png,gif,jpeg,jpg"
																input-accept="image/jpg,image/jpeg,image/png"
																v-bind:crop="false"
																v-on:imageuploaded="imageuploadedType"						
																text="上传"
																inputOfFile="file"
																:url="picUrl"
																:headers="{'access-token':this.accesstoken}"
																v-bind:class="['btn','btn-primary','col-sm-2','col-offset-sm-1']"
															>
													</vue-core-image-upload>
													<span class="col-sm-7 control-label gray t_left">请上传jpg、jpeg或png格式的图片</span>
												</div>
											</div>
										</div>
										<div class="text-center form-group col-sm-9">
												<button class="btn btn-primary" @click="confirmType">{{carTypeEditBtn}}</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<sub-modal ref="modal2" size="small" title="温馨提示">
						<p v-text="tipContent"></p>	
						<div slot="footer">
							<button class="btn btn-primary" @click="closeSub('modal2')">确定</button>
						</div>
				</sub-modal>
			</div>
		</div>
	</div>
</template>

<script>
	import VueCoreImageUpload from 'vue-core-image-upload'
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import SubModal from 'components/common/SubModal'
	export default{
		components:{
			VueCoreImageUpload,
			SubModal
		},
		data(){
			return{
				loadingstatus:false,
				dataSource:null,
				fatr:3,
				picUrl:process.env.API_ROOT +"/account/customers/logo",
				logoImgBrand:{}	,								//品牌logo
				logoSrcBrand:'',
				logoImgSeries:{},									//车系logo
				logoSrcSeries:'',
				logoImgType:{},										//车型logo
				logoSrcType:'',
				carList:[],
				tipContent:'',
				carBrandEditMsg:'',
				carSeriesEditMsg:'',
				carTypeEditMsg:'',
				carBrandEditBtn:'',
				carSeriesEditBtn:'',
				carTypeEditBtn:'',
				carBrand:{
					name:'',
					fullName:'',
					initial:'',
				},
				carSeries:{
					serialName:'',
				},
				carType:{
					modelName:'',
				},
				setting: {
					data: {
		                simpleData: {
		                    enable: true,
		                    pIdKey: "parentId",
		                },
		           	},
		           	callback: {
		           		onCheck: null,
		           		beforeEditName: this.beforeEditName,
		           		beforeAsync:this.getOtherCarData,
		           	},
		           	view:{
		           		addHoverDom: this.addHoverDom,
						removeHoverDom: this.removeHoverDom,
		           	},
				     edit: {
						enable: true,
						editNameSelectAll: true,
						showRemoveBtn: this.showRemoveBtn,
						showRenameBtn: this.showRemoveBtn,
					},
					async: {
						enable: true,
						url:this.getUrl,
						headers:{'access_taken':"dsafsf"},
						type:'get',
						dataFilter:null,
						autoParam:[],
						otherParam:[],
					},
				},
			}
		},
		computed:{
			accesstoken:function(){
				return this.$store.state.user.accesstoken
			},
		},
		beforeMount(){
			this.getCarTree();
		},
		methods:{
			//图片上传相关
			imageuploadedBrand(res){
				if(res.success){
					this.logoImgBrand = res.data//传给后台的信息
					this.logoSrcBrand = process.env.PIC_PATH + res.data;
				}else{
					this.tipContent = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$refs.modal2.open();
				}
			},
			imageuploadedSeries(res){
				if(res.success){
					this.logoImgSeries = res.data//传给后台的信息
					this.logoSrcSeries = process.env.PIC_PATH + res.data;
				}else{
					this.tipContent = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$refs.modal2.open();
				}
			},
			imageuploadedType(res){
				if(res.success){
					this.logoImgType = res.data//传给后台的信息
					this.logoSrcType = process.env.PIC_PATH + res.data;
				}else{
					this.tipContent = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$refs.modal2.open();
				}
			},
			//zTree相关
			//编辑按钮处理函数
			beforeEditName(treeId, treeNode){
				let self=this;
				if(treeNode.depth==1||treeNode.depth==2){
					this.carBrand.name=treeNode.name;
					this.carBrand.brandId=treeNode.id;
					this.carBrand.fullName=treeNode.fullName;
					this.carBrand.initial=treeNode.treeNode;
					this.fatr=1;
					this.carBrandEditMsg='编辑该品牌信息';
					this.carBrandEditBtn='保存'
					this.editType='editBrand'
				}
				if(treeNode.depth==3){
					this.carSeries.serialName=treeNode.name;
					this.carSeries.brandId=treeNode.parentId;
					this.carSeries.serialId=treeNode.id;
					this.fatr=2; 
					this.carSeriesEditMsg='编辑该车系信息';
					this.carSeriesEditBtn='保存'
					this.editType='editSeries'
				}
				if(treeNode.depth==4){
					let tempNodeId=treeNode.parentId;
					const treeObj = $.fn.zTree.getZTreeObj("carTree");
					let tempNode=treeObj.getNodeByParam('id',tempNodeId);
					this.carType.brandId=tempNode.parentId;
					this.carType.modelId=treeNode.id;
					this.carType.modelName=treeNode.name;
					this.carType.serialId=treeNode.parentId;
					this.fatr=0;
					this.carTypeEditMsg='编辑该车型信息';
					this.carTypeEditBtn='保存'
					this.editType='editType'
				}
				return false;
			},
			showRemoveBtn(treeId,treeNode){
				if(treeNode.source==1)return false;
				return true;
			},
			//节点添加按钮处理函数
			addHoverDom(treeId, treeNode) {
				let self=this;
				var sObj = $("#" + treeNode.tId + "_span");
				if(treeNode.depth==4)return false;
				if (treeNode.editNameFlag || $("#addBtn_"+treeNode.tId).length>0) return;
				var addStr = "<span class='button add' id='addBtn_" + treeNode.tId
					+ "' title='add node' onfocus='this.blur();'></span>";
				sObj.after(addStr);
				var btn = $("#addBtn_"+treeNode.tId);
				if (btn) btn.bind("click", function(){
					if(treeNode.depth==1||treeNode.depth==2){
						self.fatr=2; 
						self.carSeriesEditMsg="请输入在该品牌下要添加的车系信息";
						self.carSeriesEditBtn="保存"
						self.setEmpty(self,'Series');
						self.carSeries.brandId=treeNode.id;
						self.editType='addSeries'
					};
					if(treeNode.depth==3){
						self.fatr=0;
						self.carTypeEditMsg='请输入在该车系下要添加的车型信息';
						self.carTypeEditBtn="保存";
						self.setEmpty(self,'Type');
//						let treeObj=$.fn.zTree.getZTreeObj("carTree");
//						let tempNode=treeObj.getNodeByParam('id',treeNode.parentId);
						self.carType.serialId=treeNode.id;
						self.carType.brandId=treeNode.parentId;
						self.editType='addType'
					}
					return false;
				});
			},
			removeHoverDom(treeId, treeNode) {
				$("#addBtn_"+treeNode.tId).unbind().remove();
			},
			treeInit(){
				$.fn.zTree.init($("#carTree"), this.setting, this.carList);
			},
			//异步加载url处理函数
			getUrl(treeId,treeNode){
				let param;
				//if(treeNode.depth==2||treeNode.depth==1)
				if(treeNode.brandName){
					param=process.env.API_ROOT+'/vehicle/vehicles/serials?autoBrandId='+treeNode.id;
					return param;
				}
				//if(treeNode.depth==3)
				if(treeNode.serialName){
					param=process.env.API_ROOT+'/vehicle/vehicles/models?autoSerialId='+treeNode.id;
					return param;
				}
			},
			getOtherCarData(treeId,treeNode){
				let self=this;
				let param=this.getUrl(treeId,treeNode);
				let tempList;
				this.$http.get(param)
				.then((res)=>{
					if(res.body.success){
						tempList= res.body.data;
						if(tempList.length==0){
							return false;
						}
						tempList.map(item=>{
							self.setName(item);
						});
						this.carList=this.carList.concat(tempList);
						this.treeInit();
						const treeObj = $.fn.zTree.getZTreeObj("carTree");
						let tempNode=treeObj.getNodeByTId(treeNode.tId);
						treeObj.expandNode(tempNode,true);
					}else{
						this.tipContent=res.body.message;
						this.openSub('modal2');	
					}
				},(res)=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
				}).catch((res)=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
				})
				return false;
			},
			//zTree数据加载
			getCarTree(){
				let self=this;
				this.loadingstatus=true;
				this.$http.get(process.env.API_ROOT+'/vehicle/vehicles/brands')
				.then((res)=>{
					if(res.body.success){
						let tempList;
						this.carList = res.body.data;
						this.carList.map(item=>{
							self.setName(item);
						});
						this.treeInit();
					}else{
						this.tipContent=res.body.message;
							this.openSub('modal2');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.tipContent=res.body.message;
							this.openSub('modal2');
							this.loadingstatus=false;
				}).catch((res)=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
					this.loadingstatus=false;
				})
				return false;
			},
			//添加车辆品牌重置
			addCarBrand(){
				this.carBrandEditMsg='请输入要添加的品牌信息';
				this.carSeriesEditMsg='请输入在该品牌下要添加的车系信息';
				this.carTypeEditMsg='请输入在该车系下要添加的车型信息';
				this.carBrandEditBtn="下一步";
				this.carSeriesEditBtn="下一步";
				this.carTypeEditBtn="保存";
				this.editType="addBrand";
				this.fatr=1;
				this.setEmpty(this,'Brand','Series','Type')
			},
			//品牌页面提交按钮
			confirmBrand(){
				if(this.carBrand.fullName==''){
					this.tipContent='品牌全称为必填项';
					this.openSub('modal2');
					return false;
				};
				if(this.carBrand.initial==''){
					this.tipContent='品牌首字母为必填项';
					this.openSub('modal2');
					return false;
				};
				if(this.carBrand.initial==''){
					this.tipContent='品牌名称为必填项';
					this.openSub('modal2');
					return false;
				};
				if(this.logoSrcBrand==''){
					this.tipContent='请上传品牌LOGO';
					this.openSub('modal2');
					return false;
				};
				if(this.editType=='addBrand'){
					this.fatr=2;
				}else if(this.editType=='editBrand'){
					const para={
						brandId:this.carBrand.brandId,
						fullName:this.carBrand.fullName,
						initial:this.carBrand.initial,
						logoUrl:this.logoSrcBrand,
					}
					this.loadingstatus=true;
					this.$http.put(process.env.API_ROOT+'/vehicle/brand/brands/'+this.carBrand.brandId,para)
					.then((res)=>{
						if(res.body.success){
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}else{
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}
						this.loadingstatus=false;
					},(res)=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					}).catch((res)=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					})
				}
			},
			//车系页面提交按钮
			confirmSeries(){
				if(this.carSeries.serialName==''){
					this.tipContent='车系名称为必填项';
					this.openSub('modal2');
					return false;
				};
				if(this.logoSrcSeries==''){
					this.tipContent='请上传车系LOGO';
					this.openSub('modal2');
					return false;
				};
				if(this.editType=='addBrand'){
					this.fatr=0;
				}else if(this.editType=='editSeries'){
					const para={
						brandId:this.carBrand.brandId,
						fullName:this.carBrand.fullName,
						initial:this.carBrand.initial,
						logoUrl:this.logoSrcBrand,
					}
					this.loadingstatus=true;
					this.$http.put(process.env.API_ROOT+'/vehicle/brand/brands/'+this.carBrand.brandId,para)
					.then((res)=>{
						if(res.body.success){
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}else{
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}
						this.loadingstatus=false;
					},(res)=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					}).catch((res)=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					})
				}else if(this.editType=='addSeries'){
					this.loadingstatus=true;
					this.$http.post(process.env.API_ROOT+'/vehicle/brand/brands/{brandId}/serial')
				}
			},
			confirmType(){
				if(this.carType.modelName==''){
					this.tipContent='车型名称为必填项';
					this.openSub('modal2');
					return false;
				};
				if(this.logoSrcType==''){
					this.tipContent='请上传车型LOGO';
					this.openSub('modal2');
					return false;
				};
				if(this.editType=='addBrand'){
					const para={
						fullName:this.carBrand.fullName,
						initial:this.carBrand.initial,
						logoUrl:this.logoSrcBrand,
						modelLogoUrl:this.logoSrcType,
						modelName:this.carType.modelName,
						name:this.carBrand.name,
						serialLogoUrl:this.loadSrcSeries,
						serialName:this.carSeries.serialName,
						source:0,
					}
					this.loadingstatus=true;
					this.$http.post(process.env.API_ROOT+'/vehicle/brands/serial/model/',para)
					.then(res=>{
						if(res.body.success){
							this.tipContent='添加成功’';
							this.openSub('modal2');
						}else{
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}
						this.loadingstatus=false;
					},res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					}).catch(res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					})
				}else if(this.editType=='addType'){
					this.loadingstatus=true;
					this.$http.post(process.env.API_ROOT+'/vehicle/brand/brands/'+this.carType.brandId+'/serial/'+this.carType.seriesId+'/model/',this.carType)
					.then(res=>{
						if(res.body.success){
							this.tipContent='添加成功’';
							this.openSub('modal2');
						}else{
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}
						this.loadingstatus=false;
					},res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					}).catch(res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					})
				}else if(this.editType=='editType'){
					this.loadingstatus=true;
					this.$http.put(process.env.API_ROOT+'/vehicle/brand/brands/'+this.carType.brandId+'/serial/'+this.carType.seriesId+'/model/',+this.carType.modelId,this.carType)
					.then(res=>{
						if(res.body.success){
							this.tipContent='添加成功’';
							this.openSub('modal2');
						}else{
							this.tipContent=res.body.message;
							this.openSub('modal2');
						}
						this.loadingstatus=false;
					},res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					}).catch(res=>{
						this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
					})
				}
			},
			deleteBtn(treeId,treeNode){
				let param;
				if(treeNode.depth==1||treeNode.depth==2){
					param=process.env.API_ROOT+"/vehicle/brand/brands/"+treeNode.id;
				};
				if(treeNode.depth==3){
					param=process.env.API_ROOT+"/vehicle/brand/brands/"+treeNode.parentId+"/serial"
				}
				if(treeNode.depth==4){
					let tempNodeId=treeNode.parentId;
					const treeObj = $.fn.zTree.getZTreeObj("carTree");
					let tempNode=treeObj.getNodeByTId(tempNodeId);
					param=process.env.API_ROOT+" /vehicle/brand/brands/"+tempNode.parentId+"/serial/"+treeNode.parentId+"/model/"
				}
				this.loadingstatus=true;
				this.$http.delete(param)
				.then((res)=>{
					if(res.body.success){
						this.tipContent=res.body.message;
						this.openSub('modal2');
					}else{
						this.tipContent=res.body.message;
						this.openSub('modal2');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.tipContent=res.body.message;
						this.openSub('modal2');
						this.loadingstatus=false;
				}).catch(res=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
					this.loadingstatus=false;
				})
			},
			setName(item){
				if(item.depth!=4){
					item.isParent=true;
				};
				if(item.serialName){
					item.name=item.serialName;
				}else if(item.modelName){
					item.name=item.modelName
				}else if(item.brandName){
					item.name=item.brandName
				}
			},
			openSub(ref){
				this.$refs[ref].open();
			},
			closeSub(ref){
				this.$refs[ref].close();
			},
			setEmpty(self,...types){
				if(types.indexOf ('Brand')!=-1){
					self.carBrand.name='';
					self.carBrand.brandId='';
					self.carBrand.fullName='';
					self.carBrand.initial='';
				}
				if(types.indexOf ('Series')!=-1){
					self.carSeries.serialName='';
					self.carSeries.brandId='';
					self.carSeries.serialId='';
				}
				if(types.indexOf ('Type')!=-1){
					self.carType.brandId='';
					self.carType.modelId='';
					self.carType.modelName='';
					self.carType.serialId='';
				}
			},
			toSync(){
				this.loadingstatus=true;
				this.$http.get(process.env.API_ROOT+'/vehicle/sync')
				.then(res=>{
					if(res.body.success){
						this.tipContent=res.body.message;
						this.openSub('modal2');
					}else{
						this.tipContent=res.body.message;
						this.openSub('modal2');
					}
					this.loadingstatus=false;
				},res=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
					this.loadingstatus=false;
				}).catch(res=>{
					this.tipContent=res.body.message;
					this.openSub('modal2');
					this.loadingstatus=false;
				})
			},
		}
	}
</script>

<style>
	.ztree-slide {
	    margin-top: 10px;
	    border: 1px solid #617775;
	    background: #ffffff;
	    width: 220px;
	    height: 500px;
	    overflow-y: scroll;
	    overflow-x: auto;
	},
	#carContent{
		width:100%;
		margin: auto;
		top:100px;
		margin-left:100px;
	},
	#tip{            
		 position:absolute;     
		 display:inline-block;       
		 width:80px;             
		 height:80px;             
		 top:50%;             
		 left:50%;             
		 transform:translate(-50%,-50%);             
		 -webkit-transform:translate(-50%,-50%);             
		 -moz-transform:translate(-50%,-50%);             
		 -ms-transform:translate(-50%,-50%);             
		 }

</style>


// WEBPACK FOOTER //
// PageVehicleBrandEdit.vue?4166a3ef